import authAxios from "../utils/authAxios";

const audioClient = {
    /**
     * Временная ссылка на озвучку по ref из ответа слова. Ref выпускает сервер:
     * в нём вид субъекта (слово/определение/пример), по которому работает платный
     * гейт. Файл едет от S3 к браузеру напрямую, сервис отдаёт только ссылку.
     *
     * PROCESSING — синтез заказан (озвучка создаётся лениво на первое нажатие),
     * повторяем с паузой, пока файл не будет готов. UNAVAILABLE — файла нет, и
     * заказать его этот пользователь не вправе: наружу уходит машинный код, а слова
     * подбирает вызывающий.
     */
    getAudioLink: async ({ ref, locale }) => {
        const maxAttempts = 8;
        for (let attempt = 1; ; attempt += 1) {
            const response = await authAxios(`/api/audio/link`, {
                method: 'POST',
                data: { ref, locale },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response?.status === 'READY') {
                return response.url;
            }
            if (response?.status === 'UNAVAILABLE') {
                const unavailable = new Error('Audio is not available');
                unavailable.code = 'AUDIO_UNAVAILABLE';
                throw unavailable;
            }
            if (attempt >= maxAttempts) {
                const timedOut = new Error('Audio synthesis is taking too long');
                timedOut.code = 'PROCESSING_TIMEOUT';
                throw timedOut;
            }
            await new Promise((resolve) => setTimeout(resolve, 1500));
        }
    },
};

export default audioClient;
